<template>
  <el-dialog title="客服留言"
    :visible.sync="show"
    append-to-body
    modal
    width="740px"
    id="dialog-wrap"
    destroy-on-close
    :before-close="close"
    @closed="resetDialog"
    :close-on-click-modal="false">
    <el-alert
      title="留言内容将通过客服机器人推送给客户，请注意使用规范话术"
      type="warning"
      show-icon>
    </el-alert>
    <el-form label-width="108px" :model="form" ref="form"
      style="overflow: hidden;margin-top: 8px;">
      <el-form-item label=" ">
        <el-select v-model="targetId" style="width: 100px" placeholder="请选择">
          <el-option v-for="item in clueOptions" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        <el-input style="width:250px;" v-model="form.receiptNo"></el-input>
        <el-button class="btns" type="primary" @click="getContent">查询</el-button>
      </el-form-item>
      <el-form-item label="留言模板：" prop="compensateType" :rules="[{ required: true, message: '请选择留言模板' }]">
        <el-select v-model="form.compensateType" style="width: 200px" placeholder="请选择" filterable @change="getSopChange">
          <el-option v-for="item in targetValue ? leaveMsgSopList : []" :key="item.sopId" :label="item.title" :value="item.sopId">
          </el-option>
        </el-select>
      </el-form-item>
      <div v-for='(item,index) in sopDetailList.sopDataList' :key="index" style="margin-bottom: 6px">
        <template v-if="item.systemNodeCache==null">
          <el-form-item label="选择子订单：" prop="compensateReason" v-if="item.showType == 5">
            <div class="goods-wrapper">
              <card-detail-template
                isType
                :sopWorkFlowDetail="item"
                :sopDetailList="sopDetailList"
                @getCheckInvoices="getCheckInvoices"
                @getReselection="getReselection"
                >
              </card-detail-template>
            </div>
          </el-form-item>
          <template v-else-if="item.showType == 2">
            <el-form-item label="留言内容：" prop="leaveMsg" :rules="[{ required: true, message: '请输入' }]">
              <ElInput type="textarea" style="width:420px;" :value="item.interactionDesc || form.leaveMsg" v-model="item.interactionDesc" numberWord :maxlength="200" @input="($event) => form.leaveMsg = $event" @blur="updateMessageText($event, item)" autofocus v-focus/>
            </el-form-item>
            <el-form-item label="客户选项：">
              <el-radio-group v-model="item.checkedId" @input="getLinkStep(item)">
                <el-radio-button
                  v-for="radio in item.customOptions"
                  :label="radio.nodeId"
                  :key="radio.nodeId">{{radio.optionName}}</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </template>
          <el-form-item label="执行动作：" v-else-if="item.nodeType==='solution'">
            <div class="action-list">
              <div class="action-row" v-if="(item.solutionNode && item.solutionNode.solutionType||'').includes('8')">
                售后申请状态：
                <span class="status">{{getStatusByType(item.solutionNode, 8)}}</span> 
                <el-button @click="addshouhouBtn(item.solutionNode)">预申请售后</el-button>
              </div>
              <div class="action-row" v-if="(item.solutionNode && item.solutionNode.solutionType||'').includes('9')">
                补偿申请状态：
                <span class="status">{{getStatusByType(item.solutionNode, 9)}}</span> <el-button @click="getApplyCompensation(item.solutionNode)">预申请补偿</el-button>
              </div>
              <div class="action-row" v-if="(item.solutionNode && item.solutionNode.solutionType||'').includes('10')">
                工单提交状态：
                <span class="status">{{getStatusByType(item.solutionNode, 10)}}</span> <el-button @click="createWorkOrder(item.solutionNode)">预提交工单</el-button>
              </div>
              <div class="action-row" 
                v-if="!item.solutionNode || 
                  (
                    !(item.solutionNode.solutionType || '').includes('8') &&
                    !(item.solutionNode.solutionType || '').includes('9') &&
                    !(item.solutionNode.solutionType || '').includes('10')
                  )">
                暂无
              </div>
              <!-- <div class="action-row" v-if="(item.solutionNode && item.solutionNode.solutionType||'').includes(11)">
                工单催促
              </div> -->
            </div>
          </el-form-item>
        </template>
        <el-form-item
          label="系统判断："
          v-if="item.systemNodeCache && item.systemNodeCache.combineTips">{{item.systemNodeCache.combineTips }}</el-form-item>
      </div>
      <div v-show="sopDetailList && sopDetailList.lastNodeFlag">
        <el-button type="primary" style="display: block; margin: 0 auto"
          @click="sumbit('form', true, true, true)" v-preventReClick>确认提交</el-button>
        <!-- <el-button @click="close">取消</el-button> -->
      </div>
    </el-form>
    <!-- 申请补偿 -->
    <el-drawer title="申请补偿" :modal='false' id="drawer-body" :visible.sync="drawerCompensate"
      :style="{ height: midHeight + 'px' }"
      :before-close="handleDrawerCompensateClose">
      <div class='elDrawer-body' :style="{ height: maxHeight + 'px' }">
        <newAddCompensate ref='newCompensateRef' 
        :sumbit="createCompensate"></newAddCompensate>
      </div>
    </el-drawer>
    <!-- 创建工单 -->
    <el-drawer title="创建工单" :modal='false' id="drawer-body" :visible.sync="showServerNotes" :withHeader="false"
      :style="{ height: midHeight + 'px' }"
      :before-close="closeWorkOrder">
      <div class='elDrawer-body' :style="{ height: maxHeight + 'px' }">
        <create-order @close="showServerNotes=false" v-if="showServerNotes" showHeader @reload="()=> {}" ref="createOrderRef" :sumbit="createServerNotes"></create-order>
      </div>
    </el-drawer>
    <!-- 申请售后 -->
    <el-drawer title="申请售后" :modal='false' id="drawer-body" :visible.sync="showAddAfterOrder"
      :style="{ height: midHeight + 'px' }"
      :before-close="handleCloseAddAfterOrder">
      <div class='elDrawer-body' :style="{ height: maxHeight + 'px' }">
        <addAfterOrder ref='addAfterOrder' :sumbit="createAfterOrder"></addAfterOrder>
      </div>
    </el-drawer>
  </el-dialog>
</template>

<script>
import { mapState } from 'vuex'
// import cache from '@/utils/formCache'
import newAddCompensate from '@/views/invoices/voucher/addCompensate/newCompensate.vue'
import createOrder from '@/views/workOrderManagement/allWorkOrder/createWorkOrder.vue'
import addAfterOrder from '@/views/work/components/addAfterOrder/addAfter.vue'
import cardDetailTemplate from '@/views/work/components/sopslider/components/cardDetailTemplate.vue'
import * as http from './service'

export default {
  name: 'ServiceMessageDarwer',
  components: {
    newAddCompensate,
    createOrder,
    cardDetailTemplate,
    addAfterOrder
  },
  computed: {
    ...mapState({
      arrlist: state => state.work.arrlist,
      index: state => state.work.index,
      showmid: state => state.work.showmid,
      oldflg: state => state.work.oldflg,
      oldlist: state => state.work.oldlist,
      oldnow: state => state.work.oldnow,
      nowlist: state => state.work.nowlist,
      empIds: state => state.work.empIds
    })
  },
  directives: {
    focus: {
      inserted(el) {
        el.querySelector('textarea').focus()
      }
    }
  },
  data() {
    return {
      show: false,
      showAddAfterOrder: false,
      showServerNotes: false,
      targetId: '',
      targetValue: '',
      clueOptions: [
        {
          label: '订单',
          value: 1
        }, {
          label: '手机号',
          value: 10
        }
      ],
      form: {
        receiptNo: '',
        leaveMsg: '',
        compensateType: ''
      },
      drawerCompensate: false,
      orderObj: {
        orderItemBo: [],
        logisticsBeanList: []
      },
      midHeight: 0,
      maxHeight: 0,
      // 详情版接收参数
      sopDetailList: {
        channelId: '',
        channelContent: '',
        sopId: '',
        oriSopId: '',
        sopList: [],
        targetShowContent: '',
        sopDataList: [
          {
            showType: 0
          }
        ]
      },
      leaveMsgSopList: [],
      canSumbit: false,
      channelId: '',
      channelContent: '',
      consumerId: '',
      isYiXian: false,
      orderBizType:'',
    }
  },
  mounted() {
    this.midHeight = window.innerHeight - 62
    this.maxHeight = window.innerHeight - 126
  },
  methods: {
    open(params) {
      if (params) {
        this.channelId = params.channelId || ''
        this.channelContent = params.channelContent || ''
        this.consumerId = params.consumerId || ''
        this.workOrderCode = params.workOrderCode || ''
        this.isYiXian = params.isYiXian || false
      } else {
        console.log('创建留言入参：', params)
        this.$message.error('未获取到channel相关参数')
        return
      }
      this.requestId = `t${Date.now()}`
      this.getLeaveMsgSopList()
      if (params && params.orderId) {
        this.targetId = 1
        this.form.receiptNo = params.orderId
      } else if (params && params.phone) {
        this.targetId = 10
        this.form.receiptNo = (params.phone || '').replace(/^86/, '')
      }
      this.show = true
    },
    getLinkStep(item) {
      const id = item.checkedId

      if (item.customOptions && item.customOptions.length === 1) {
        return
      }
      const params = {
        operationType: 2,
        consumerId: this.consumerId,
        channelId: this.sopDetailList.channelId, // 二线工作台传2
        channelContent: this.sopDetailList.channelContent, // 当前对话的sessionId，
        sopId: this.sopDetailList.sopId,
        selectType: 2, // 选择类型 1订单选择 2自定义选择 3售后单选择器 4商品选择器
        selectContent: id, // 当 selectType为自定义选择器的时候 取当前按钮的nodeid,订单选择取 订单ID，售后选择去售后ID，商品选择取商品ID
        nodeId: item.nodeId,
        nodeType: item.nodeType,
        nodeOptionId: id // 自定义交互点时。selectContent和nodeOptionId取当前选中的nodeId
      }
      this.getsopdetail(params)
    },
    // 选中当前订单模板
    getCheckInvoices(data) {
      const params = {
        operationType: 2,
        channelId: this.sopDetailList.channelId, // 二线工作台传2
        channelContent: this.sopDetailList.channelContent, // 当前对话的sessionId，
        sopId: this.sopDetailList.sopId,
        oriSopId: this.sopDetailList.oriSopId,
        selectType: data.type, // 选择类型 1订单选择 2自定义选择 3售后单选择器 4商品选择器
        selectContent: data.id, // 当 selectType为自定义选择器的时候 取empNodeOptionId,订单选择取 订单ID，售后选择去售后ID，商品选择取商品ID
        nodeId: data.item.nodeId,
        nodeType: data.item.nodeType,
        nodeOptionId: data.item.nodeOptionId
      }
      this.getsopdetail(params)
    },
    close() {
      this.show = false
      this.$refs.form.resetFields()
    },
    handleDrawerCompensateClose() {
      this.drawerCompensate = false
    },
    // 查询
    getContent() {
      const { targetId } = this
      if (!targetId && targetId !== 0) {
        this.$message.error('请选择线索类型')
        return
      }
      const content = this.form.receiptNo
      if (!content || !targetId) return
      const sessionId = this.oldflg ? this.nowlist.sessionId : this.oldnow.sessionId
      const params = {
        consumerId: this.consumerId,
        additional: 'orderId',
        targetId
      }
      if (sessionId) {
        params.content = content
        params.sessionId = sessionId
      } else {
        params.ifShowSensitive = 1
        params.panelId = 3
        params.channelId = 3
        params.channelContent = content
        params.targetContent = content
      }
      this.targetValue = ''
      http.getOrder(params).subscribe(
        (res) => {
          if (res.data) {
            try {
              this.consumerId = res.data[0].targetDetailContent.userInfoRO.consumerId || res.data[0].targetDetailContent.userInfoRO.consumerId
            } catch (error) {
              console.log('未取到consumerId：', error)
            }
            this.orderBizType =  res.data[0].targetDetailContent.orderBizType
            if (targetId == 10 && !res.data[0].targetDetailContent.userInfoRO) {
              this.$message.error('查询不到手机号，请检查后重新查询')
              this.targetValue = ''
              return
            }
            this.targetValue = content
            this.$message.success('查询通过')
          }
        }
      )
    },
    // 提交
    sumbit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })
          const params = {
            requestId: this.requestId,
            sopId: this.form.compensateType,
            channelId: this.channelId,
            channelContent: this.channelContent,
            workOrderCode: this.workOrderCode,
            targetType: this.targetId,
            consumerId: this.consumerId
          }
          if (this.targetId === 1) {
            params.orderId = this.form.receiptNo
          } else if (this.targetId === 10) {
            params.phone = this.form.receiptNo
          }
          http.submitLeaveMsgApi(params).subscribe(() => {
            this.close()
            loading.close()
          }, () => loading.close())
        }
      })
    },
    // 打开申请补偿
    getApplyCompensation(item) {
      this.drawerCompensate = true
      this.$nextTick(() => {
        const compensateType = Number(this.targetId === 10 ? 2 : this.targetId)
        this.$refs.newCompensateRef.targetId = compensateType
        this.$refs.newCompensateRef.afterSaleForm.compensateType = compensateType
        this.$refs.newCompensateRef.afterSaleForm.receiptNo = this.targetValue

        const formData = item.draftCacheVoList && item.draftCacheVoList.find(i => i.solutionType == 9 && i.status === 1 && i.requestJson)
        if (formData) {
          const requestJson = JSON.parse(formData.requestJson)
          this.$refs.newCompensateRef.initInfo(requestJson)
        } else {
          this.$refs.newCompensateRef.getOrderInfo(1, false, true)
        } 
      })
    },
    // 打开预申请工单
    createWorkOrder(item) {
      const params = {
        woCluesType: this.targetId,
        targetId: this.targetId,
        woCluesCode: (this.targetValue || '').replace(/^86/, '')
      }
      this.showServerNotes = true
      this.$nextTick(() => {
        const formData = item.draftCacheVoList && item.draftCacheVoList.find(i => i.solutionType == 10 && i.status === 1 && i.requestJson)
        if (formData) {
          this.$refs.createOrderRef.setFormData(JSON.parse(formData.requestJson))
        } else {
          switch (Number(params.woCluesType)) {
            case 10:
            case 25:
              params.woCluesType = 15
              break
            default:
              break
          }
          this.$refs.createOrderRef.setFormData(params)
        }
      })
    },
    // 关闭申请工单弹窗
    closeWorkOrder() {
      this.showServerNotes = false
    },
    // 关闭申请售后
    handleCloseAddAfterOrder() {
      this.showAddAfterOrder = false
    },
    // 点击申请售后按钮
    addshouhouBtn(item) {
      const { orderId, subOrderId } = item.order || {}
      if (orderId && orderId.startsWith('YJZM')) {
        this.$message.warning('升级订单不支持售后')
        return
      }
      
      if (orderId && orderId.startsWith('YJHJC')) {
        this.$message.warning('黄精茶订单不支持留言售后')
        return
      }
      if('晨茶招募订单' === this.orderBizType) {
        this.$message.warning(this.orderBizType + '不支持留言售后')
        return
      }
      this.showAddAfterOrder = true
      this.$nextTick(() => {
        const formData = item.draftCacheVoList && item.draftCacheVoList.find(i => i.solutionType == 8 && i.status === 1 && i.requestJson)
        if (formData) {
          const requestJson = JSON.parse(formData.requestJson)
          this.$refs.addAfterOrder.setFormData(requestJson.echoData)
          return
        }
        this.$refs.addAfterOrder.getOrderInfo(orderId || this.sopDetailList.sopDataList.channelContent, subOrderId)
      })
    },
    // 切换sop
    getSopChange(val) {
      const data = {
        channelId: this.channelId,
        operationType: 1,
        channelContent: this.channelContent,
        targetId: this.targetId,
        targetContent: this.targetValue,
        consumerId: this.consumerId,
        sopId: val
      }
      this.getsopdetail(data)
    },
    beforeShow(data) {
      let lastItem = {} // 上个系统item
      for (const item of data.sopDataList) {
        if (item.systemNodeCache != null) { // combine
          let tips = `${item.systemNodeCache.nodeName} = `
          for (const option of item.systemNodeCache.options) {
            if (option.name === item.systemNodeCache.checkedId) {
              tips += option.value
            }
          }
          if (lastItem && lastItem.systemNodeCache != null) {
            lastItem.systemNodeCache.combineTips = `${lastItem.systemNodeCache.combineTips}, ${tips}`
            lastItem.systemNodeCache.combineNodes = `${lastItem.systemNodeCache.combineNodes}, ${item.systemNodeCache.nodeId}`
          } else {
            item.systemNodeCache.combineTips = tips
            lastItem = item
          }
        } else {
          lastItem = {}
        }
      }
      return data
    },
    // 缩略版sop
    getsopdetail(data) {
      // this.params.consumerId = this.nowlist.userdata.consumerId // 拿到外部传入的consumerId
      const datas = Object.assign({}, data)
      if (this.sopDetailList.oriSopId) {
        datas.oriSopId = this.sopDetailList.oriSopId
      }
      http.handleSopCustomerService({ 
        requestId: this.requestId, 
        consumerId: this.consumerId,
        ...datas 
      }, { type: 'formData' }).subscribe(
        (res) => {
          if (res.data) { // 避免没有数据时候报错
            this.showsop = true
            this.sopdrawerDetail = false
            this.sopDetailList = this.beforeShow(res.data)
          }
          if (res.data && res.data.sopDataList) {
            this.targetShowTip = res.data.targetShowTip
            res.data.sopDataList.forEach((i) => {
              if (i.showType == 2 && i.interactionDesc) {
                i.interactionDesc = i.interactionDesc.replace(/<[^>]+>/g, '')
                i.interactionDesc = i.interactionDesc.replace(/&nbsp;/g, ' ')
              }
              // 当重选标识为1时，走下面逻辑
              if (i.ifReSelect === 1) {
                if (i.orderRefundData) {
                  i.orderRefundData.forEach((j) => {
                    if (j.returnId == i.checkedId) {
                      j.showflg = false
                    } else {
                      j.showflg = true
                    }
                  })
                }
                if (i.orderData) {
                  i.orderData.forEach((z) => {
                    if (z.orderId == i.checkedId) {
                      z.showflg = false
                    } else {
                      z.showflg = true
                    }
                  })
                }
                if (i.itemData) {
                  i.itemData.forEach((v) => {
                    if (v.itemId == i.checkedId) {
                      v.showflg = false
                    } else {
                      v.showflg = true
                    }
                  })
                }
                if (i.customOptions) {
                  i.customOptions.forEach((g) => {
                    if (g.nodeId == i.checkedId) {
                      g.showFlg = false
                    } else {
                      g.showFlg = true
                    }
                  })
                }
              }
            })
            this.sopDetailList = res.data
          }
          if (res.response.data.errorMessage && res.response.data.errorMessage !== null) {
            if (this.errorMessageString(res.response.data.errorMessage)) {
              this.$message.error(res.response.data.errorMessage)
            }
          }
        }
      )
    },
    errorMessageString(str) {
      let isFlg = false
      if (str.substr(0, 4) === '1003' || str.substr(0, 4) === '1004') {
        isFlg = true
      } else {
        isFlg = false
      }
      return isFlg
    },
    getLeaveMsgSopList() {
      const params = {}
      if (this.isYiXian) {
        params.recommendStartLevel = 1
        params.recommendSecondLevel = 5
      } else {
        params.recommendStartLevel = 2
        params.recommendSecondLevel = 2
      }
      http.getLeaveMsgSopApi(params).subscribe((res) => {
        if (res.data) {
          this.leaveMsgSopList = res.data
        }
      })
    },
    getStatusByType(solutionNode, type) {
      let result = '待提交'
      try {
        // const sopItem = this.sopDetailList.sopDataList.find(item => item.showType == 2)
        // const formItem = sopItem.customOptions.find(opt => opt.nodeId === sopItem.checkedId)
        // result = formItem[formName]
        const node = solutionNode.draftCacheVoList.find(item => item.solutionType == type)
        result = node.status === 1 ? '已提交' : '待提交'
      } catch (error) {
        console.log(`getSopOptByNodeId error: ${error}`)
        result = '待提交'
      }
      return result
    },
    getCheckedItem() {
      return this.sopDetailList.sopDataList.find(item => item.showType == 2)
    },
    getSopOpt() {
      const sopItem = this.getCheckedItem()
      const formItem = sopItem.customOptions.find(opt => opt.nodeId === sopItem.checkedId)
      return formItem
    },
    // 预申请补偿
    createCompensate(compensateCreateAo) {
      try {
        const checkedItem = this.getCheckedItem()
        this.savaFormJson(JSON.stringify(compensateCreateAo), 9).then(() => {
          this.getLinkStep(checkedItem)
          this.drawerCompensate = false
        })
        // this.$message.success('预补偿申请提交成功')
      } catch (error) {
        console.log('预补偿申请提交失败', error)
        this.$message.error('预补偿申请提交失败')
      }
    },
    // 预申请工单
    createServerNotes(workOrderForm, { formItemList, form }) {
      try {
        const checkedItem = this.getCheckedItem()
        console.log('createServerNotes:', workOrderForm)
        workOrderForm.templateData = { formItemList, form }
        this.savaFormJson(JSON.stringify(workOrderForm), 10).then(() => {
          this.getLinkStep(checkedItem)
          this.showServerNotes = false
        })
        // this.$message.success('预创建售后提交成功')
      } catch (error) {
        console.log('预创建工单提交失败', error)
        this.$message.error('预创建工单提交失败')
      }
    },
    // 预申请售后
    createAfterOrder(echoData, afterSaleForm) {
      try {
        const checkedItem = this.getCheckedItem()
        this.savaFormJson(JSON.stringify({ echoData, afterSaleForm }), 8).then(() => {
          this.getLinkStep(checkedItem)
          this.showAddAfterOrder = false
        })
        // this.$message.success('预创建售后提交成功')
      } catch (error) {
        console.log('预申请售后提交失败', error)
        this.$message.error('预申请售后提交失败')
      }
    },
    // 暫存表單
    savaFormJson(requestJson, solutionType) {
      const sopItem = this.getCheckedItem()
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      return new Promise((reslove) => {
        http.handleDraftCacheApi({
          requestId: this.requestId,
          nodeId: sopItem.checkedId,
          sopId: this.sopDetailList.sopId,
          solutionType,
          requestJson
        }).subscribe(() => {
          loading.close()
          reslove()
        }, () => {
          loading.close()
        })
      })
    },
    // 更新留言信息方法
    updateMessageText(e, item) {
      this.form.leaveMsg = e.target.value
      if (!this.sopDetailList.sopId || !e.target.value) return
      http.handleMsgContentCacheApi({
        requestId: this.requestId,
        sopId: this.sopDetailList.sopId,
        nodeId: item.nodeId,
        msgContentCache: e.target.value
      }).subscribe(() => {
        console.log(e.target.value)
      })
    },
    // 点击重选
    getReselection() {
      if (this.$refs.cardTemplate) {
        for (let i = 0; i < this.$refs.cardTemplate.length; i++) {
          if (this.$refs && this.$refs.cardTemplate && this.$refs.cardTemplate[i]) this.$refs.cardTemplate[i].cleanTree()
        }
      }
      const newojb = JSON.parse(JSON.stringify(this.sopDetailList))
      newojb.sopDataList.forEach((i) => {
        i.ifReSelect = 0
        i.ifOpen = 1
        i.checkedId = ''
        // 遍历显示隐藏字段
        if (i.orderRefundData) {
          i.orderRefundData.forEach((j) => {
            j.showflg = false
          })
        }
        if (i.orderData) {
          i.orderData.forEach((z) => {
            z.showflg = false
          })
        }
        if (i.itemData) {
          i.itemData.forEach((v) => {
            v.showflg = false
          })
        }
        if (i.customOptions) {
          i.customOptions.forEach((g) => {
            g.showFlg = false
          })
        }
      })
      this.setnewdata(newojb)
    },
    // 把数据新增选中以及不选中
    setnewdata(newdata) {
      this.sopDetailList = JSON.parse(JSON.stringify(newdata))
    },
    // 重置弹窗
    resetDialog() {
      const defalutData = this.$options.data()
      // Object.assign(this.$data, { ...defalutData })
      this.sopDetailList = { ...defalutData.sopDetailList }
    }
  }
}
</script>

<style lang="less" scoped>
#dialog-wrap {
  
  /deep/ .contentWarp .content-right{
    line-height: normal !important;
    max-width: 200px;
  }
  .action-list {
    width: 420px;
    border: 1px solid #bfcbd9;

    .action-row {
      padding: 10px;

      .status {
        margin: 0 20px;
      }

      &:not(:last-child) {
        border-bottom: 1px solid #bfcbd9;
      }
    }

  }

  .goods-info-wrapper {
    flex: 1;

    .info-wrapper-flex {
      display: flex;

      img {
        width: 50px;
        height: 50px;
        margin: 6px 10px 0;
        border: 1px solid #eee;
      }

      .goods-info {
        flex: 1;

        h4,
        p {
          margin: 0;

          label {
            float: right;
          }
        }
      }
    }
  }
}
#drawer-body {
  width: 640px;
  top: 60px;
  left: unset;
  box-shadow:
    0 8px 10px -5px rgba(0, 0, 0, .2),
    0 16px 24px 2px rgba(0, 0, 0, .14),
    0 6px 30px 5px rgba(0, 0, 0, .12);
  /deep/ .el-drawer__header {
    margin-bottom: 14px;
    font-size: 15px;
    font-weight: 600;
    color: #333333;
  }
  /deep/ .el-drawer {
      width: 100% !important;
    }
  /deep/.elDrawer-body {
    overflow: auto;
  }
}
</style>
